export default __webpack_public_path__ + "static/media/loader.99caad5a.gif";